// @flow

import { get } from 'lodash/fp';

export const formValues = get('form.tokenisedPayment.values');
